import React from "react";
import { connect } from "react-redux";
import moment from "moment";
import { 
	Table,
	Button,
	Modal,
	Spin,
	Input,
} from 'antd';

import "./style.css";
import LayoutWrapper from '../../layouts/LayoutWrapper';
import ReduxComponent from '../ReduxComponent';
import courseLibraryService from "../../services/Training/course-library-service";
import {
	changeTrainingCourse,
	selectTrainingCourse,
} from "../../actions/training-actions";
import { fetchEmployeesList } from '../../actions/employee-management-actions.js';
const webConfig = require ('../../config.json');


class CourseLibrary extends ReduxComponent {

	initReload = true;
	moduleName = "training";
	childModuleName = "courseLibrary";

	state = {
		detailData: {},
		detailStatus: "unload",
	}

	actions = {
		changeAction: this.props.changeTrainingCourse,
		selectAction: this.props.selectTrainingCourse,
	}

	setTypeFilter = event => this.actions.changeAction({
		training_type: event.target.value
	}, "reload")

	setEmployeeFilter = value => this.actions.changeAction({
		//real_name: value,
		training_teacher_name: value//,
		//job_number: value
	}, "reload")

	setPageFilter = pagination => this.actions.changeAction({
		page: pagination.current
	}, "reload")

	openDetailModal = modelId => this.setState({
		detailModalStatus: true,
		detailStatus: "unload",
	}, () => courseLibraryService.selectTrainingCourseDetail({modelId: modelId}, res => {
		if (200 === res.status) {
			if ("内部培训" === res.data.training_type_name) {
				res.data.training_teacher_name = res.data.training_it_teacher_name;
			}
			this.setState({
				detailData: res.data,
				detailStatus: "loaded",
			});
		}else{
			this.setState({detailStatus: "error"})
		}
	}, err => this.setState({detailStatus: "error"})))

	closeDetailModal= () => this.setState({
		detailModalStatus: false,
	});

	column = [{
			title: '培训名称',
			dataIndex: 'training_name',
			key: 'training_name',
			className: 'table-global-head-short'
		},{
			title: '培训类型',
			dataIndex: 'training_type_name',
			key: 'training_type_name',
			className: 'table-global-head-short'
		}, {
			title: '课程类型',
			dataIndex: 'training_courses_type_name',
			key: 'training_courses_type_name',
			className: 'table-global-head-short'
		}, {
			title: '讲师',
			dataIndex: 'training_teacher_name',
			key: 'training_teacher_name',
			className: 'table-global-head'
		}, {
			title: '发布时间',
			dataIndex: 'created_time',
			key: 'created_time',
			className: 'table-global-head'
			// render: text => text ? moment(text).format("YYYY-MM-DD HH:MM") : null
		}, {
			title: '开始时间',
			dataIndex: 'training_start_date',
			key: 'training_start_date',
			className: 'table-global-head'
			// render: text => text ? moment(text).format("YYYY-MM-DD HH:MM") : null
		}, {
			title: '结束时间',
			dataIndex: 'training_end_date',
			key: 'training_end_date',
			className: 'table-global-head'
			// render: text => text ? moment(text).format("YYYY-MM-DD HH:MM") : null
		}, {
			title: '计划培训人数',
			dataIndex: 'planned_training_count',
			key: 'planned_training_count',
			className: 'table-global-head-short'
		}, {
			title: '申请人数',
			dataIndex: 'actual_training_count',
			key: 'actual_training_count',
			className: 'table-global-head-small'
		}, {
			title: '操作',
			dataIndex: 'actions',
			key: 'actions',
			className: 'table-global-head-small',
			render: (text, record, index) => {
				return (
					<span>
						{this.props.access.courseLibrary.detail_value && <Button icon="edit" size="small"
							className="row-action-btn"
							onClick={this.openDetailModal.bind(this, record.id)}>详情</Button>}
					</span>
				);
			} 
		}
	];

	employeeColumn = [{
			title: '姓名',
			dataIndex: 'real_name',
			key: 'real_name',
			className: 'table-global-head'
		}, {
			title: '工号',
			dataIndex: 'job_number',
			key: 'job_number',
			className: 'table-global-head-short'
		}, {
			title: '部门',
			dataIndex: 'department_name',
			key: 'department_name',
			className: 'table-global-head'
		}, {
			title: '联系电话',
			dataIndex: 'phone',
			key: 'phone',
			className: 'table-global-head'
		}, {
			title: '邮箱',
			dataIndex: 'email',
			key: 'email',
			className: 'table-global-head-large'
		}, {
			title: '申请时间',
			dataIndex: 'created_date',
			key: 'created_date',
			className: 'table-global-head',
			render: text => text ? moment(text).format("YYYY-MM-DD HH:mm") : null
		}
	];

	render() {

		return (
			<div className="app-module-item">
				<div style={{marginBottom: "20px"}}>
					<div className="colAction" style={{float:"left", margin:"0px 10px 10px 0px"}}>
						<select onChange={this.setTypeFilter}
							style={{width:'116px',height:'32px',display:'inline-block',paddingLeft:'5px'}}
							value={this.props[this.moduleName][this.childModuleName].filters.training_type} >
							<option value={""}>全部</option>
							<option value={0}>内部培训</option>
							<option value={1}>外部培训</option>
						</select>
					</div>
					<div className="colAction" style={{float:"left", margin:"0px 10px 10px 0px"}}>
						<Input.Search
							placeholder="讲师 工号/姓名"
							onSearch={this.setEmployeeFilter}
							style={{ width: 200 }}
							defaultValue={null}
							enterButton />
					</div>
					<div style={{clear: "both"}}></div>
				</div>
				<Modal width="1000px"
					visible={this.state.detailModalStatus}
					title="培训详情"
					destroyOnClose={true}
					onCancel={this.closeDetailModal}
					footer={<Button onClick={this.closeDetailModal}>关闭</Button>}>
					<div style={{textAlign:"center",margin:"0px 0px 5px",height:"500px",overflowY:"auto"}}>
					{(() => {
						switch (this.state.detailStatus) {
							case "loaded":
								return (
									<div>
										<div>
											<div className="modal-content-item">
												<span className="modal-content-title">培训名称:</span>
												<span className="modal-content-body">
													{this.state.detailData.training_name}
												</span>
											</div>
											<div className="modal-content-item">
												<span className="modal-content-title">课程类型:</span>
												<span className="modal-content-body">
													{this.state.detailData.training_courses_type_name}
												</span>
											</div>
											<div className="modal-content-item">
												<span className="modal-content-title">培训老师:</span>
												<span className="modal-content-body">
													{this.state.detailData.training_teacher_name}
												</span>
											</div>
											<div className="modal-content-item">
												<span className="modal-content-title">培训时间:</span>
												<span className="modal-content-body">
													{this.state.detailData.training_start_date ? 
														moment(this.state.detailData.training_start_date).format("YYYY/MM/DD HH:mm") : null}
													&nbsp;&nbsp;&nbsp;-&nbsp;&nbsp;&nbsp;
													{this.state.detailData.training_end_date ?
														moment(this.state.detailData.training_end_date).format("YYYY/MM/DD HH:mm") : null}
												</span>
											</div>
											<div className="modal-content-item">
												<span className="modal-content-title">培训价格:</span>
												<span className="modal-content-body">
													{this.state.detailData.training_price}
												</span>
											</div>
											<div className="modal-content-item">
												<span className="modal-content-title">计划培训人数:</span>
												<span className="modal-content-body">
													{this.state.detailData.planned_training_count}
												</span>
											</div>
											<div className="modal-content-item">
												<span className="modal-content-title">实际培训人数:</span>
												<span className="modal-content-body">
													{this.state.detailData.actual_training_count}
												</span>
											</div>
										</div>
										<div style={{marginTop: "30px"}}>
											<h4 style={{textAlign: "left"}}>参加培训员工列表:</h4>
											<Table columns={this.employeeColumn}
												bordered
												dataSource={this.state.detailData.must_employees}
												rowKey={record => record.id}
												pagination={false} />
										</div>
										<div style={{marginTop: "30px"}}>
											<h4 style={{textAlign: "left"}}>开放培训员工参加列表:</h4>
											<Table columns={this.employeeColumn}
												bordered
												dataSource={this.state.detailData.optional_employees}
												rowKey={record => record.id}
												pagination={false} />					
										</div>
									</div>);
							case "error":
								return (
									<div style={{textAlign:'center', margin: '100px 0px'}}>
										{webConfig.httpFetchErrorInformation}
									</div>);
							case "loading":
							case "reload":
							case "unload":
								return (
									<div style={{textAlign:'center', margin: '100px 0px'}}>
										<Spin size="large" />
									</div>);
							default :
								return null;
						}
					})()}
					</div>
				</Modal>
				<div>
					{(() => {
						switch (this.props[this.moduleName][this.childModuleName].dataStatus) {
							case "reload":
							case "loaded":
								return (
									<Table columns={this.column}
									dataSource={this.props[this.moduleName][this.childModuleName].data.Data}
									rowKey={record => record.id}
									scroll={{x: 800}}
									// rowSelection={this.rowSelection}
									pagination={{
										total: this.props[this.moduleName][this.childModuleName].data.Total,
										pageSize: this.props[this.moduleName][this.childModuleName].data.PageSize,
										current: this.props[this.moduleName][this.childModuleName].filters.page}}
									onChange={this.setPageFilter} />)
							case "error":
								return (
									<div style={{textAlign:'center', margin: '100px 0px'}}>
										{webConfig.httpFetchErrorInformation}
									</div>);
							case "loading":
							case "unload":
								return (
									<div style={{textAlign:'center', margin: '100px 0px'}}>
										<Spin size="large" />
									</div>);
							default :
								return null;
						}
					})()}
				</div>
			</div>
		)
	}
}

const mapStateToProps = state => {
	return {
		training: state.training
	}
}

const mapDispatchToProps = {
	fetchEmployeesList,
	changeTrainingCourse,
	selectTrainingCourse,
}


export default LayoutWrapper(connect(mapStateToProps, mapDispatchToProps)(CourseLibrary));







// WEBPACK FOOTER //
// ./src/routes/Training/CourseLibrary.js